import { Action } from '@ngrx/store';

export enum AuthActionTypes {
  LOGIN = '[Auth] Login',
  LOGIN_SUCCESS = '[Auth] Login Success',
  LOGIN_FAILURE = '[Auth] Login Failure',

  LOGOUT = '[Auth] Logout',
  LOGOUT_SUCCESS = '[Auth] Logout Success',
  LOGOUT_FAILURE = '[Auth] Logout Failure',

  SET_USER_PREFS = '[Auth] SET User Prefs',
  SET_USER_PREFS_SUCCESS = '[Auth] SET User Prefs Success',

  GET_USER = '[Auth] GET User',
  GET_USER_SUCCESS = '[Auth] GET User Success',
  GET_USER_FAILURE = '[Auth] GET User Failure',

  UPDATE_USER = '[Auth] Update User',
  UPDATE_USER_SUCCESS = '[Auth] Update User Success',
  UPDATE_USER_FAILURE = '[Auth] Update User Failure',

  GET_USER_DASH = '[Auth] GET User Dash',
  GET_USER_DASH_SUCCESS = '[Auth] GET User Dash Success',
  GET_USER_DASH_FAILURE = '[Auth] GET User Dash Failure',

  SSO = '[Auth] SSO Login',
  SSO_SUCCESS = '[Auth] SSO Login Success',
  SSO_FAILURE = '[Auth] SSO Login Failure',
}

export class LogIn implements Action {
  readonly type = AuthActionTypes.LOGIN;
  constructor(public payload: any) {}
}

export class LogInSuccess implements Action {
  readonly type = AuthActionTypes.LOGIN_SUCCESS;
  constructor(public payload: any) {}
}

export class LogInFailure implements Action {
  readonly type = AuthActionTypes.LOGIN_FAILURE;
  constructor(public payload: any) {}
}

export class LogOut implements Action {
  readonly type = AuthActionTypes.LOGOUT;
  constructor(public payload: any) {}
}
export class LogOutSuccess implements Action {
  readonly type = AuthActionTypes.LOGOUT_SUCCESS;
  constructor(public payload: any) {}
}
export class LogOutFailure implements Action {
  readonly type = AuthActionTypes.LOGOUT_FAILURE;
  constructor(public payload: any) {}
}
export class SetUserPrefs implements Action {
  readonly type = AuthActionTypes.SET_USER_PREFS;
  constructor(public payload: any) {}
}
export class SetUserPrefsSuccess implements Action {
  readonly type = AuthActionTypes.SET_USER_PREFS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetUser implements Action {
  readonly type = AuthActionTypes.GET_USER;
  constructor(public payload: any) {}
}

export class GetUserSuccess implements Action {
  readonly type = AuthActionTypes.GET_USER_SUCCESS;
  constructor(public payload: any) {}
}

export class GetUserFailure implements Action {
  readonly type = AuthActionTypes.GET_USER_FAILURE;
  constructor(public payload: any) {}
}

export class GetUserDash implements Action {
  readonly type = AuthActionTypes.GET_USER_DASH;
  constructor(public payload: any) {}
}

export class GetUserDashSuccess implements Action {
  readonly type = AuthActionTypes.GET_USER_DASH_SUCCESS;
  constructor(public payload: any) {}
}

export class GetUserDashFailure implements Action {
  readonly type = AuthActionTypes.GET_USER_DASH_FAILURE;
  constructor(public payload: any) {}
}

export class UpdateUser implements Action {
  readonly type = AuthActionTypes.UPDATE_USER;
  constructor(public payload: any) {}
}

export class UpdateUserSuccess implements Action {
  readonly type = AuthActionTypes.UPDATE_USER_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateUserFailure implements Action {
  readonly type = AuthActionTypes.UPDATE_USER_FAILURE;
  constructor(public payload: any) {}
}

export class SSO implements Action {
  readonly type = AuthActionTypes.SSO;
  constructor(public payload: any) {}
}

export class SSOSuccess implements Action {
  readonly type = AuthActionTypes.SSO_SUCCESS;
  constructor(public payload: any) {}
}

export class SSOFailure implements Action {
  readonly type = AuthActionTypes.SSO_FAILURE;
  constructor(public payload: any) {}
}

export type All =
  | LogIn
  | LogInSuccess
  | LogInFailure
  | LogOut
  | LogOutSuccess
  | LogOutFailure
  | SetUserPrefs
  | SetUserPrefsSuccess
  | GetUser
  | GetUserSuccess
  | GetUserFailure
  | UpdateUser
  | UpdateUserSuccess
  | UpdateUserFailure
  | GetUserDash
  | GetUserDashSuccess
  | GetUserDashFailure
  | SSO
  | SSOSuccess
  | SSOFailure;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/auth.actions.ts